<template>
   <transition name="slide">

  <div id="stats_item_page" class="centered" v-if="loaded">

      <div class="col-md-6">
          <div id="stats_box">

              <div class="menu">
                  <a v-for="type in types" :key="type.id" v-text="type.name" @click="activeType = type" :class="(type.id==activeType.id ? 'active' : '')"></a>
              </div>

                <div class="inner">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>שם נקודת השידור</th>
                                    <th>האזנה אחרונה</th>
                                    <th class="center">האזנות</th>
                                    <th class="center">הורדה</th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr v-for="line in activeType.items" :key="line.id" >
                                    <td v-text="line.name"></td>
                                    <td v-text="line.date"></td>
                                    <td class="center" v-text="line.br_views"></td>
                                    <td class="center"  v-text="line.br_downloads"></td>
                                </tr>
                            </tbody>

                        </table>

                    </div>

                </div>

          </div>
      </div>


      <div class="col-md-6">
          <div class="data">
            <div class="stats_icons">
                <div class="box">
                    <div class="icon"><i class="fas fa-microphone-alt"></i></div>
                    <h3 v-text="format_number(2)"></h3>
                    <p>הופיע במצעד</p>
                </div>
                <div class="box">
                    <div class="icon"><i class="fab fa-searchengin"></i></div>
                    <h3 v-text="format_number(item.total_views || 0)"></h3>
                    <p> סך כל האזנות</p>
                </div>
                <div class="box">
                    <div class="icon"><i class="fas fa-laptop-house"></i></div>
                    <h3 v-text="format_number(item.num_linkipedia || 0)"></h3>
                    <p> כניסות מלינקיפדיה</p>
                </div>
            </div>

              <div class="stats_graphs">
                  <div class="box">
                      <h4>צפיות של הלינקטון</h4>
                     <BarChart :data="chartdata" :options="{}"></BarChart>

                  </div>
                  
                  <div class="box">
                        <h4>מדיות מובילות</h4>
                         <PieChart :data="piechartdata" :options="{}"></PieChart>

                  </div>
              </div>
                        

          </div>
      </div>

      <div class="clr"></div>
  </div>
   </transition>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue';
import PieChart from '@/components/charts/PieChart.vue';

export default {
    components:{BarChart,PieChart},
    props: ["id","item"],
  data(){ 
    return {
      loaded: false,
      types: [],
      activeType:{},
         chartdata: {
        labels: ['January', 'February'],
        
        datasets: [
          {
            label: 'Data One',
            backgroundColor:this.$store.color_array,
            data: [40, 20]
          }
        ]
      },
      piechartdata: {
            labels: ['sdf', 'sdf', 'dfgfdgdfg'],
            datasets: [
                {
                    fill: true,
                    backgroundColor: this.$store.color_array,
                    data: [5, 95, 20],
                    borderColor: this.border_array,
                    borderWidth: [1,1]
                }
            ]
          },

    }
  },

  mounted(){
    this.api({ action: 'stats_item_data', data: {id: this.id} }, (data) => { 
        
        for(let i in data.data.types)
        {
            data.data.types[i].is_active = false;
        }
        this.types = data.data.types;

        this.activeType = data.data.types[0];
        this.piechartdata.labels = Object.values(data.data.types).map(function(rows) { return rows.name}).slice(0,4);
        this.piechartdata.datasets[0].data = Object.values(data.data.types).map(function(rows) { return parseInt(rows.num); }).slice(0,4);
        this.chartdata.labels = Object.values(data.data.total_views_mounth).map(function(rows) { return rows.label});
        this.chartdata.datasets[0].data = Object.values(data.data.total_views_mounth).map(function(rows) { return parseInt(rows.val); });
 

      this.loaded = true;
    });

  }
  
}
</script>

<style lang="scss">
#stats_item_page{margin-bottom: 30px;}
.slide-enter-active {
   -moz-transition-duration: 0.5s;
   -webkit-transition-duration: 0.5s;
   -o-transition-duration: 0.5s;
   transition-duration: 0.5s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.5s;
   -webkit-transition-duration: 0.5s;
   -o-transition-duration: 0.5s;
   transition-duration: 0.5s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 700px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
.data{
    &{margin-top: 30px;}
    
    .stats_icons { display: flex; gap:20px; margin-bottom: 20px;
        .box { flex: 1;}
    }
    .stats_graphs { display: flex; gap:20px; margin-bottom: 20px;
        @media (min-width: 600px) { }
        @media (max-width: 600px) { flex-direction: column; }
        
        .box { flex: 1;}
    }

    .icon{font-size: 43px;margin-bottom: 20px; color: #737373; }
        .box{text-align: center;; border-radius: 8px;box-shadow: 0 6px 14px 0 rgba(88, 91, 111, 0.08);background-color: #f4f4f4;padding: 30px 10px 30px;}
        h3{font-size: 45px;margin-bottom: 15px;}
    }
#stats_box {
    
    &{margin: 30px 0;}
    overflow: hidden; background: #f4f4f4;
    .inner { padding: 10px; overflow: auto;
    
        @media (min-width: 600px) { float: right; width:calc(100% - 150px); height: 560px; }
        @media (max-width: 600px) {  }

    }
    .inner{
        table {
            &{width: 100%;}
            tr{border-bottom: 1px solid rgba(151, 151, 151, 0.2);min-height: 30px;display: block;margin-bottom: 5px;display: flex;justify-content: space-around;padding: 5px 0;}
            td,th{flex-basis: 25%;padding: 0 3px;}
            .center{text-align: center;}
            thead tr{border-bottom: none;}
        }
    }
    .menu {  background: #47494f; 

        @media (min-width: 600px) { float: right; width:150px; padding: 0 2px; }
        @media (max-width: 600px) { display: flex; overflow-y: auto;  }

        a { display: flex; text-align: center; color: #fff; opacity: 0.5; align-items: center; justify-content: center; position: relative; border-bottom: solid 1px #979797; 
            
            @media (min-width: 600px) { height:70px;  }
            @media (max-width: 600px) { padding: 0 20px; }
        }
        a:hover,a.active { opacity: 1;
            
            @media (min-width: 600px) { 
                &::after{ content: ""; display: block; position: absolute; left: 0px; top: 0px; height: 100%; width: 3px; background: #ff256e; border-radius: 5px;} 
            }
            @media (max-width: 600px) { background: #ff256e; }

            
        }
    }
}
.stat_ttl { color: #ff256e; font-weight: bold; }
</style>